import {
  CloseButton,
  Hidden,
  IconButton,
  Stack,
  TextField,
} from '@backyard-ui/core';
import { ScanBarcodeOutline } from '@backyard-ui/icons';
import { FormEvent, useState } from 'react';

import styles from './Searchbar.styles';

import { BarcodeDetector } from './BarcodeDetector';
import { PLACEHOLDER } from './constants';

function AssistedSaleSearchbar() {
  const [term, setTerm] = useState('');
  const [showBarcodeScanner, setShowBarcodeScanner] = useState(false);

  const barcodeDetectorProps = {
    showBarcodeScanner,
    setShowBarcodeScanner,
  };

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();

    const termEncoded = encodeURIComponent(term);

    if (termEncoded) {
      window.location.href = `/search?term=${term}&searchTerm=${term}&searchType=default`;
    }
  };

  const handleClear = () => {
    setTerm('');
  };

  return (
    <>
      <div className={styles({}).base()}>
        <form
          name="assisted-sale-form"
          className={styles().form()}
          onSubmit={handleSubmit}
          data-testid="assisted-sale-form"
        >
          <TextField.Root>
            <TextField.Input
              name="assisted-sale-input"
              placeholder={PLACEHOLDER}
              UNSAFE_className={styles().input()}
              value={term}
              onChange={(event) => setTerm(event.target.value)}
              data-testid="assisted-sale-input"
            />

            <TextField.Slot>
              <Stack align="center" spacing={1}>
                {term && (
                  <Hidden above="md">
                    <CloseButton
                      type="reset"
                      ariaLabel="Limpar campo de busca"
                      size="xs"
                      onClick={handleClear}
                    />
                  </Hidden>
                )}

                <Hidden above="md">
                  <IconButton
                    appearance="neutral"
                    variant="ghost"
                    size="xs"
                    ariaLabel="Buscar"
                    type="button"
                    icon={<ScanBarcodeOutline />}
                    UNSAFE_className="px-1 [&_svg]:w-4 [&_svg]:h-4"
                    onClick={() => setShowBarcodeScanner(true)}
                  />
                </Hidden>

                <IconButton
                  appearance="neutral"
                  variant="ghost"
                  size="xs"
                  ariaLabel="Buscar"
                  type="submit"
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 23 25"
                    >
                      <path
                        fill="currentColor"
                        d="m22.16 20.679-5.023-5.024a9.77 9.77 0 0 0 1.786-5.581c.112-5.135-4.13-9.377-9.376-9.377a9.48 9.48 0 0 0-9.489 9.489 9.48 9.48 0 0 0 9.489 9.488c1.34 0 2.79-.335 4.018-.893l5.247 5.247c.446.446 1.004.67 1.674.67.558 0 1.228-.224 1.674-.67l.112-.112c.447-.447.67-1.005.67-1.563-.112-.67-.335-1.228-.782-1.674Zm-5.916-10.493c0 3.683-3.014 6.697-6.697 6.697-3.684 0-6.698-3.014-6.698-6.697 0-3.684 3.014-6.698 6.698-6.698 3.683 0 6.697 3.014 6.697 6.698Z"
                      />
                    </svg>
                  }
                  UNSAFE_className="px-1 [&_svg]:w-4 [&_svg]:h-4"
                  data-testid="button-submit"
                />
              </Stack>
            </TextField.Slot>
          </TextField.Root>
        </form>
      </div>

      <Hidden above="md">
        <BarcodeDetector {...barcodeDetectorProps} />
      </Hidden>
    </>
  );
}

export default AssistedSaleSearchbar;
